import { ChangeDetectorRef, QueryList } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SprayBoothStudyFormComponent } from './spray-booth-study-form/spray-booth-study-form.component';
import { asEnumerable } from 'linq-es2015';
import { RecurrencePattern } from "../../../shared/services/request.service";
import { ExperimentDesignFormValidatorsService } from '../experiment-design-form/experiment-design-form-validators.service';
var SprayBoothStudyComponent = /** @class */ (function () {
    function SprayBoothStudyComponent(fb, cdRef, validators) {
        this.fb = fb;
        this.cdRef = cdRef;
        this.validators = validators;
    }
    SprayBoothStudyComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.getSprayStudyOptions();
        this.setTooltipText();
        this.isSprayBooth = this.experimentDesignFormGroup.get('sprayStudy').value === true;
        this.experimentDesignFormGroup.get('sprayStudy').valueChanges.subscribe(function (val) {
            _this.isSprayBooth = val === true;
            var treatments = _this.experimentDesignFormGroup.get('treatments');
            if (treatments && treatments.controls) {
                for (var i = 0; i < treatments.length; i++) {
                    var treatment = treatments.at(i);
                    var sprayBoothStudy = treatment.get('sprayBoothStudy');
                    if (val === true && sprayBoothStudy && sprayBoothStudy.length === 0) {
                        var sprayEventGroup = _this.fb.group({
                            applicationVolumeId: [null, Validators.required],
                            applicationTimepointId: [null, Validators.required],
                            actives: _this.fb.array([]),
                            adjuvants: _this.fb.array([]),
                        });
                        sprayEventGroup.setValidators(_this.validators.atLeastOneActiveOrAdjuvantValidator());
                        sprayBoothStudy.push(sprayEventGroup);
                        sprayEventGroup.updateValueAndValidity();
                    }
                    _this.toggleSprayBoothValidators(treatment, val === true);
                }
            }
        });
        this.experimentDesignFormGroup.get('recurrencePattern').valueChanges.subscribe(function (val) {
            _this.setTooltipText();
        });
        this.activeOptions = this.ceRequestOptions.actives;
        this.adjuvantOptions = this.ceRequestOptions.adjuvants;
    };
    SprayBoothStudyComponent.prototype.ngAfterViewInit = function () {
        this.cdRef.detectChanges();
    };
    SprayBoothStudyComponent.prototype.toggleSprayBoothValidators = function (treatment, enabled) {
        var sprayBoothStudy = treatment.get('sprayBoothStudy');
        if (sprayBoothStudy && sprayBoothStudy.controls) {
            for (var j = 0; j < sprayBoothStudy.length; j++) {
                var sprayGroup = sprayBoothStudy.at(j);
                this.toggleSprayEventFields(sprayGroup, enabled);
                this.toggleActivesValidators(sprayGroup.get('actives'), enabled);
                this.toggleAdjuvantsValidators(sprayGroup.get('adjuvants'), enabled);
                if (enabled) {
                    sprayGroup.setValidators(this.validators.atLeastOneActiveOrAdjuvantValidator());
                }
                else {
                    sprayGroup.clearValidators();
                }
                sprayGroup.updateValueAndValidity();
            }
        }
    };
    SprayBoothStudyComponent.prototype.toggleSprayEventFields = function (sprayGroup, enabled) {
        var volume = sprayGroup.get('applicationVolumeId');
        var timepoint = sprayGroup.get('applicationTimepointId');
        if (enabled) {
            volume.setValidators([Validators.required]);
            timepoint.setValidators([Validators.required]);
        }
        else {
            volume.clearValidators();
            timepoint.clearValidators();
        }
        volume.updateValueAndValidity();
        timepoint.updateValueAndValidity();
    };
    SprayBoothStudyComponent.prototype.toggleActivesValidators = function (actives, enabled) {
        if (!actives) {
            return;
        }
        for (var k = 0; k < actives.length; k++) {
            var group = actives.at(k);
            var activeId = group.get('activeId');
            var rateValue = group.get('rateValue');
            var rateUnitId = group.get('rateUnitId');
            var relativeFieldRate = group.get('relativeFieldRate');
            if (enabled) {
                activeId.setValidators([Validators.required]);
                rateValue.setValidators([Validators.required, Validators.min(0)]);
                rateUnitId.setValidators([Validators.required]);
                relativeFieldRate.setValidators([Validators.required]);
            }
            else {
                activeId.clearValidators();
                rateValue.clearValidators();
                rateUnitId.clearValidators();
                relativeFieldRate.clearValidators();
            }
            activeId.updateValueAndValidity();
            rateValue.updateValueAndValidity();
            rateUnitId.updateValueAndValidity();
            relativeFieldRate.updateValueAndValidity();
        }
    };
    SprayBoothStudyComponent.prototype.toggleAdjuvantsValidators = function (adjuvants, enabled) {
        if (!adjuvants) {
            return;
        }
        for (var k = 0; k < adjuvants.length; k++) {
            var group = adjuvants.at(k);
            var adjuvantId = group.get('adjuvantId');
            var adjuvantValue = group.get('adjuvantValue');
            if (enabled) {
                adjuvantId.setValidators([Validators.required]);
                adjuvantValue.setValidators([Validators.required, Validators.min(0)]);
            }
            else {
                adjuvantId.clearValidators();
                adjuvantValue.clearValidators();
            }
            adjuvantId.updateValueAndValidity();
            adjuvantValue.updateValueAndValidity();
        }
    };
    SprayBoothStudyComponent.prototype.disableFormValidation = function () {
        var sprayControl = this.experimentDesignFormGroup.get('sprayStudy');
        var treatments = this.experimentDesignFormGroup.get('treatments');
        var firstTreatment = treatments.at(0);
        var sprayBoothStudy = firstTreatment.get('sprayBoothStudy');
        if (sprayControl && sprayBoothStudy) {
            var isSprayEnabled = sprayControl.value === true;
            for (var i = 0; i < sprayBoothStudy.length; i++) {
                var group = sprayBoothStudy.at(i);
                var controls = group.controls;
                for (var key in controls) {
                    if (controls.hasOwnProperty(key)) {
                        var control = controls[key];
                        if (isSprayEnabled) {
                            if (key === 'applicationTimepointId' || key === 'applicationVolumeId') {
                                control.setValidators([Validators.required]);
                            }
                            else if (key === 'actives' || key === 'adjuvants') {
                            }
                            else {
                                control.setValidators(null);
                            }
                        }
                        else {
                            control.clearValidators();
                            control.setErrors(null);
                        }
                        control.updateValueAndValidity({ onlySelf: true });
                    }
                }
                if (isSprayEnabled) {
                    group.setValidators(null);
                }
                else {
                    group.clearValidators();
                    group.setErrors(null);
                }
                group.updateValueAndValidity({ onlySelf: true });
            }
            if (isSprayEnabled) {
                sprayBoothStudy.setValidators(null);
            }
            else {
                sprayBoothStudy.clearValidators();
                sprayBoothStudy.setErrors(null);
            }
            sprayBoothStudy.updateValueAndValidity({ onlySelf: true });
        }
    };
    SprayBoothStudyComponent.prototype.setTooltipText = function (val) {
        if (val === void 0) { val = null; }
        var recurrence = val != null ? val : this.experimentDesignFormGroup.get('recurrencePattern').value;
        var sprayControl = this.experimentDesignFormGroup.get('sprayStudy');
        this.recurrencePattern = recurrence === RecurrencePattern.Weekly;
        if (this.recurrencePattern) {
            sprayControl.setValue(false);
            sprayControl.disable();
            this.tooltipText = 'Spray Booth Study Instructions are not available for recurring requests.';
        }
        else {
            sprayControl.enable();
            // tslint:disable-next-line:max-line-length
            this.tooltipText = 'Refers to chemicals that will be applied at specific timepoints for specific experimental needs. Does not refer to pesticides that may be applied for plant care purposes.';
        }
    };
    Object.defineProperty(SprayBoothStudyComponent.prototype, "treatments", {
        get: function () {
            return this.experimentDesignFormGroup.get('treatments');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SprayBoothStudyComponent.prototype, "SprayStudy", {
        get: function () {
            return this.experimentDesignFormGroup.get('sprayStudy');
        },
        enumerable: true,
        configurable: true
    });
    SprayBoothStudyComponent.prototype.getSprayBoothValue = function (event) {
        this.isSprayBooth = event === true;
    };
    SprayBoothStudyComponent.prototype.getSprayStudyOptions = function () {
        var adjuvantName = asEnumerable(this.ceRequestOptions.adjuvants)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.order; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var adjuvantUnit = asEnumerable(this.ceRequestOptions.adjuvantUnits)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.order; })
            .ThenBy(function (s) { return s.unit; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.unit
            };
        })
            .ToArray();
        var applicationVolume = asEnumerable(this.ceRequestOptions.applicationVolumes)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.order; })
            .ThenBy(function (s) { return s.volume; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.volume
            };
        })
            .ToArray();
        var applicationTimepoint = asEnumerable(this.ceRequestOptions.applicationTimepoints)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.order; })
            .ThenBy(function (s) { return s.timepoint; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.timepoint
            };
        })
            .ToArray();
        var rateUnit = asEnumerable(this.ceRequestOptions.rateUnits)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.order; })
            .ThenBy(function (s) { return s.unit; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.unit
            };
        })
            .ToArray();
        var herbicideTradeName = asEnumerable(this.ceRequestOptions.actives)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.order; })
            .ThenBy(function (s) { return s.herbicideTradeName; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.herbicideTradeName + "(" + s.factsid + ")"
            };
        })
            .ToArray();
        this.sprayStudyOptions = {
            herbicideTradeNames: herbicideTradeName,
            rateUnits: rateUnit,
            applicationTimepoints: applicationTimepoint,
            applicationVolumes: applicationVolume,
            adjuvantNames: adjuvantName,
            adjuvantUnits: adjuvantUnit
        };
    };
    SprayBoothStudyComponent.prototype.applyToAllSprayStudies = function (sourceIndex) {
        if (!this.sprayBoothStudyForms) {
            console.warn('sprayBoothStudyForms not initialized yet.');
            return;
        }
        var components = this.sprayBoothStudyForms.toArray();
        if (!components || components.length <= 1 || sourceIndex < 0 || sourceIndex >= components.length) {
            console.warn('Invalid index or not enough components to apply.');
            return;
        }
        var sourceComponent = components[sourceIndex];
        if (!sourceComponent || !sourceComponent.sprayBoothStudy || sourceComponent.sprayBoothStudy.length === 0) {
            console.warn('Source component or sprayBoothStudy is not ready.');
            return;
        }
        var sprayEvents = [];
        for (var i = 0; i < sourceComponent.sprayBoothStudy.length; i++) {
            var study = sourceComponent.sprayBoothStudy.at(i);
            if (study instanceof FormGroup) {
                sprayEvents.push({
                    applicationVolumeId: study.get('applicationVolumeId') ? study.get('applicationVolumeId').value : null,
                    applicationTimepointId: study.get('applicationTimepointId') ? study.get('applicationTimepointId').value : null,
                    actives: study.get('actives') && study.get('actives') instanceof FormArray
                        ? study.get('actives').value
                        : [],
                    adjuvants: study.get('adjuvants') && study.get('adjuvants') instanceof FormArray
                        ? study.get('adjuvants').value
                        : []
                });
            }
        }
        if (sprayEvents.length === 0) {
            console.warn('No spray events found to copy.');
            return;
        }
        var copyArgs = { sprayEvents: sprayEvents };
        for (var i = 0; i < components.length; i++) {
            var target = components[i];
            if (i !== sourceIndex && target && typeof target.copyAllSprayEvents === 'function') {
                target.copyAllSprayEvents(copyArgs);
            }
        }
    };
    return SprayBoothStudyComponent;
}());
export { SprayBoothStudyComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/spray-booth-study/spray-booth-study.component.ts.pre-build-optimizer.js